import { GraduationCap, Sparkles } from "lucide-react";

export function TrainingPanel() {
  const items = [
    { t: "How allocation & carry-forward works", d: "Walkthrough of the MNA vessel-allocation logic — TEUs per order, weekly allocation and carry-forward." },
    { t: "Reading the invoice audit", d: "How invoice lines are matched to rate cards and how variances / cost avoidance are calculated." },
    { t: "Ocean freight fundamentals", d: "Incoterms, container types, transit vs. round-voyage, direct vs. transhipment and peak-season basics." },
    { t: "Guides & documents", d: "A place to host briefings, SOPs and carrier reference material for the team." },
  ];
  return (
    <div className="space-y-6" data-testid="training-panel">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
          <GraduationCap className="w-5 h-5 text-primary" />
        </div>
        <div>
          <h2 className="font-display text-2xl font-bold tracking-tight text-slate-900">Training</h2>
          <p className="text-sm text-slate-500 mt-0.5 max-w-3xl">
            A training &amp; knowledge space for the supply-chain team. Content coming soon — tell us what to add first.
          </p>
        </div>
      </div>
      <div className="grid gap-4 md:grid-cols-2">
        {items.map((it) => (
          <div key={it.t} className="bg-white border border-slate-200 rounded-xl p-5">
            <div className="flex items-center gap-2 text-primary">
              <Sparkles className="w-4 h-4" />
              <span className="text-[11px] uppercase tracking-wider font-num text-slate-400">Coming soon</span>
            </div>
            <h3 className="font-display font-semibold text-slate-900 mt-2">{it.t}</h3>
            <p className="text-sm text-slate-500 mt-1">{it.d}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
